module.exports = __webpack_public_path__ + "img/28.d2c90ba5.png";